import React from 'react';
import { Button } from '../shadcn/button';

const SelectionBar = ({ count, onClear }) => {
  if (count === 0) return null;

  return (
    <div className="flex items-center justify-between bg-slate-900 text-white rounded-lg px-4 py-3">
      <span className="text-sm">
        {count} patient{count > 1 ? 's' : ''} selected
      </span>
      <div className="flex gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={onClear}
          className="text-slate-400 hover:text-white hover:bg-slate-800 text-xs"
        >
          Clear
        </Button>
        <Button
          size="sm"
          className="bg-white text-slate-900 hover:bg-slate-100 text-xs"
        >
          Start Campaign
        </Button>
      </div>
    </div>
  );
};

export default SelectionBar;
